const Forbidden = () =>{
    return(
        <h1>forbidden</h1>
    );
}
export default Forbidden;